import React, { PropsWithChildren } from "react"
import { Dialog } from "@/components/Dialog"

type InfoDialogProps = PropsWithChildren<{
	title: string
	open: boolean
	shouldHaveFullWidth?: boolean
	maxWidthSize?: "xs" | "sm" | "md" | "lg" | "xl"
	onClose: () => void
}>

export const InfoDialog = (props: InfoDialogProps) => {
	const {
		onClose,
		title,
		maxWidthSize,
		shouldHaveFullWidth,
		open,
		children
	} = props

	return (
		<Dialog.Container
			onClose={onClose}
			open={open}
			fullWidth={shouldHaveFullWidth}
			maxWidth={maxWidthSize}
		>
			<Dialog.Header>
				<Dialog.Title>{title}</Dialog.Title>
				<Dialog.CloseIconButton onClick={onClose} />
			</Dialog.Header>
			<Dialog.Content>
				{children}
			</Dialog.Content>
		</Dialog.Container>
	)
}